import {
    LOGIN_POP_UP_SHOW,
    LOGIN_POP_UP_CLOSE,
} from '../actions/login-popup-actions';

const initialState = {
    showPopUp: false,
    userParamsNeeded: null,
    onboardFlow: null,
    titles: null,
    performAction: null,
    extraFunctionCalls: null,
    onCloseClick: null,
    type: null,
    screen: null,
    showCloseIcon: null,
    closeOnClickOutside: null,
};

function app(state = initialState, action) {
    switch (action.type) {
        case LOGIN_POP_UP_SHOW: {
            const popUpData = action.data || {};
            return {
                ...state,
                showPopUp: true,
                userParamsNeeded: popUpData.userParamsNeeded,
                onboardFlow: popUpData.onboardFlow || 'player',
                titles: popUpData.titles,
                performAction: popUpData.performAction,
                extraFunctionCalls: popUpData.extraFunctionCalls,
                onCloseClick: popUpData.onCloseClick,
                type: popUpData.type,
                screen: popUpData?.screen,
                showCloseIcon: popUpData?.showCloseIcon,
                closeOnClickOutside: popUpData?.closeOnClickOutside,
            };
        }
        case LOGIN_POP_UP_CLOSE:
            return {
                ...state,
                showPopUp: false,
                userParamsNeeded: null,
                onboardFlow: null,
                titles: null,
                performAction: null,
                extraFunctionCalls: null,
                onCloseClick: null,
                type: null,
                screen: null,
            };
        default:
            return state;
    }
}

export default app;
